// extracted by mini-css-extract-plugin
module.exports = {"icon":"StaffingPage_icon__3zszf","text":"StaffingPage_text__3wxdZ"};